import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { NotificationDefinitionStatus } from './notification-definition.status';
import { RecipientsProviderType } from './recipients/recipients.provider.type';
import { RecipientsProviderOutputType } from './recipients/recipients.provider.output.type';

import { UserRole } from '@40seas/entities/users';
import { BusinessContactsRecipientsProviderPayload } from './recipients/business-contacts.recipients-provider.payload';
import { EmailRecipientsProviderPayload } from './recipients/email.recipients-provider.payload';
import { EntityCreatorRecipientsProviderPayload } from './recipients/entity-creator.recipients-provider.payload';

export const NotificationDefinitionSchema = WithBaseEntitySchema(
    z.object({
        eventType: z.string().min(1),
        role: EnumSchema(UserRole),
        status: EnumSchema(NotificationDefinitionStatus),
        recipientsProviderPayload: z.any().optional(),
        recipientsProviderType: EnumSchema(RecipientsProviderType).optional(),
        recipientsProviderOutputType: EnumSchema(RecipientsProviderOutputType).optional(),
    }),
).strict();

export class NotificationDefinition extends FromSchema(NotificationDefinitionSchema) implements BaseEntity {
    id: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;

    status: NotificationDefinitionStatus;
    role: UserRole;
    recipientsProviderType?: RecipientsProviderType;
    recipientsProviderOutputType?: RecipientsProviderOutputType;
    recipientsProviderPayload?:
        | EntityCreatorRecipientsProviderPayload
        | BusinessContactsRecipientsProviderPayload
        | EmailRecipientsProviderPayload;
    eventType: string;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
    seller?: string | Seller;
}
